import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

export const ScrollTop = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <button onClick={toTop} aria-label="Back to top" data-testid="scroll-top-btn"
      className={`no-print fixed bottom-6 right-6 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-[var(--teal)] text-white shadow-lg transition-[opacity,transform] duration-300 hover:bg-[var(--teal-2)] ${show ? "opacity-100" : "pointer-events-none translate-y-3 opacity-0"}`}>
      <ArrowUp className="h-5 w-5" />
    </button>
  );
};
